import React, {useEffect, useState} from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  Backdrop,
  CircularProgress,
} from "@mui/material";

import Avatar from "@mui/material/Avatar";
import Icon from "../../../../components/icon";
import { ConnectExistingStripe, CreateAndConnectStripe } from "components/StripeConnect/logic/stripe-api";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { List, ListItem, ListItemText } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const StripeSetupPage =({ handlePrev, handleNext }) => {
  const [accountOption, setAccountOption] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [displayBanner, setDisplayBanner] = useState(true);
  const navigate = useNavigate();

  const handleExistingStripeConnection = async () => {
    setLoading(true);
    try {
      // Call your backend to create a Stripe account connection
      setAccountOption("existing");
      const response = await ConnectExistingStripe(window.location.origin+'/stripe-connect/success',navigate);

      if(!response.isError){
        const url  = response.result;            
        window.open(url, '_blank'); 
      }else{
        toast.error(response.message || 'An error occurred while connecting to Stripe', {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      }
           
    } catch (error) {
      console.error('Error connecting Stripe:', error);      
    }finally{
      setLoading(false);
    }
  };
  const handleNewStripeConnection = async () => {
    setLoading(true);
    try {
      setAccountOption("new");
      // Call your backend to create a Stripe account connection
      const response = await CreateAndConnectStripe(window.location.origin+'/stripe-connect/success',navigate);

      if(!response.isError){
        const url  = response.result;            
        window.open(url, '_blank'); 
      }else{
        toast.error(response.message || 'An error occurred while connecting to Stripe', {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      }      
    } catch (error) {
      console.error('Error connecting Stripe:', error);      
    }finally{
      setLoading(false);
    }
  };


  return (
    <Box sx={{ maxWidth: 980, mx: "auto", pt: 0 }}>
      {/* Header */}
   <Box sx={{ 
  display: "flex", 
  alignItems: { xs: "center", sm: "flex-start" },
  mb: 4, 
  pt: { xs: 2, sm: 0 }, 
  pl: { xs: 0, sm: "220px" },
  ml: { xs: 0, sm: "40px" }, 
  flexDirection: { xs: "column", sm: "row" },
  textAlign: { xs: "center", sm: "left" } 
}}>
  <Avatar
    sx={{
      bgcolor: "transparent",
      border: "1px solid #e0e0e0",
      color: "text.primary",
      mr: { xs: 0, sm: 2 }, 
      mb: { xs: 2, sm: 4 }, 
      height: { xs: 40, sm: 52 }, 
      width: { xs: 40, sm: 52 }, 
      alignSelf: { xs: "center", sm: "flex-start" } 
    }}
  >
    <Icon icon="mynaui:credit-card-plus" />
  </Avatar>
  <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
  {/* Heading */}
  <Typography
    variant="h5"
    sx={{ fontSize: { xs: "1.24rem", sm: "1.24rem" } }}
  >
    Payment Processing
  </Typography>

  {/* Stripe Badge below heading */}
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      bgcolor: "#23A26D",
      borderRadius: 1,
      px: 3.5,
      py: 0.3,
      mt: 0.3, // spacing below heading
      justifyContent: "center",
    }}
  >
    <Typography
      variant="caption"
      color="white"
      sx={{ mr: 0.5, fontSize: "0.62rem", lineHeight: 1 }}
    >
      Powered by
    </Typography>
    <Icon
      icon="cib:stripe"
      width={22}
      height={22}
      style={{ color: "white" }}
    />
  </Box>

      {/* <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
      >
        Do you already have a Stripe account? If not, no worries! We'll get
        you set up right now
      </Typography> */}
    </Box>
</Box>
 {displayBanner && (
            <Grid item xs={12}>
              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  backgroundColor: 'rgb(35, 162, 109, 0.1)',
                  fontSize: '13px',
                  borderRadius: 1,
                  mb: 3,
                  p: 2,
                  maxWidth: {xs: '100%', lg: '100%'},
                  mx: 'auto'
                }}
              >
                <ul style={{ lineHeight: '1.6' }}>
                  <li><strong>Cleri </strong>partners with <strong>Stripe</strong>, an extremely secure and reliable payment processor. </li>
                  <li>With this powerful integration, you can accept instant payments via credit cards, debit cards, ACH bank transactions, and more. </li>
                  <li><strong>Cleri does not charge or collect processing fees. These are paid directly to Stripe whenever your Customers make a payment.</strong></li>
                </ul>
                <Tooltip title='Remove'>
                  <IconButton onClick={ () => setDisplayBanner(false)}>
                    <Icon icon='tabler:x' />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          )}

      {/* Account Options - Now as Buttons */}
     

      {/* Payment Processing Info */}
      {/* <Box sx={{ mb: 3 }}>
        <Paper
          elevation={0}
          sx={{
            p: {xs: 3.5, sm: 1.5},
            bgcolor: "rgba(35, 162, 109, 0.12)",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            width: "100%",
          }}
        > */}
          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" gutterBottom>
              Payment Processing
            </Typography>
           <Box sx={{ display: 'flex', alignItems: 'center' }}>
  <Box 
    sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      bgcolor: '#23A26D',
      borderRadius: 1, 
      px: 0.5,  // Reduced horizontal padding from 1 to 0.5
      py: 0.25, 
    }}
  >
    <Typography variant="caption" color="white" sx={{ mr: 0.2, fontSize: '0.43rem' }}>
      Powered by
    </Typography>
    <Icon 
      icon="cib:stripe" 
      width={33}  
      height={28} 
      style={{ color: "white" }}
    />
  </Box>
</Box>
          </Box> */}
       {/* <Box mb={1}>
  <Typography variant="body2" color="text.secondary" mb={0.5}>
    • Cleri partners with Stripe, an extremely secure and reliable payment processor. 
  </Typography>
  <Typography variant="body2" color="text.secondary" mb={0.5}>
    • With this powerful integration, you can accept instant payments via credit cards, debit cards, ACH bank transactions, and more. 
  </Typography>
  <Typography variant="body2" color="text.secondary">
    • <strong>Cleri does not charge or collect processing fees. These are paid directly to Stripe whenever your Customers make a payment.</strong>
  </Typography>
</Box>
        </Paper>
      </Box> */}

     {/* Fee Structure */}
<Box sx={{ mb: 3 }}>
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 2}, // Responsive padding
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          height: '100%', // Let content determine height
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            bgcolor: "rgba(35, 162, 109, 0.12)",
            borderRadius: "50%",
            width: 30,
            height: 30,
            alignItems: "center",
            justifyContent: "center",
            mb: 0.5, // Reduced margin
          }}
        >
          <Icon
            icon="iconoir:credit-cards"
            width={20}
            height={20}
            style={{ color: "#23A26D" }}
          />
        </Box>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 0.5 }}> {/* Reduced margin and smaller variant */}
          Credit & Debit Cards
        </Typography>
        <Typography variant="body1" color="#23A26D" sx={{ mb: 0.5 }}> {/* Reduced margin */}
          2.9% + $0.30
        </Typography>
        <Typography variant="caption" color="text.secondary"> {/* Smaller text */}
          Per transaction
        </Typography>
      </Paper>
    </Grid>
    <Grid item xs={12} md={4}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 2}, // Responsive padding
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            bgcolor: "rgba(35, 162, 109, 0.12)",
            borderRadius: "50%",
            width: 30,
            height: 30,
            alignItems: "center",
            justifyContent: "center",
            mb: 0.5,
          }}
        >
          <Icon
            icon="circum:bank"
            width={20}
            height={20}
            style={{ color: "#23A26D" }}
          />
        </Box>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 0.5 }}>
          ACH Bank Transfer
        </Typography>
        <Typography variant="body1" color="#23A26D" sx={{ mb: 0.5 }}>
          1%
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Per transaction (capped at $10)
        </Typography>
      </Paper>
    </Grid>
    <Grid item xs={12} md={4}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 2 }, // Responsive padding
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            bgcolor: "rgba(35, 162, 109, 0.12)",
            borderRadius: "50%",
            width: 30,
            height: 30,
            alignItems: "center",
            justifyContent: "center",
            mb: 0.5,
          }}
        >
          <Icon
            icon="carbon:flight-international"
            width={20}
            height={20}
            style={{ color: "#23A26D" }}
          />
        </Box>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 0.5 }}>
          International Cards
        </Typography>
        <Typography variant="body1" color="#23A26D" sx={{ mb: 0.5 }}>
          +1%
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Additional fee for international payments
        </Typography>
      </Paper>
    </Grid>
  </Grid>
</Box>
      

      {/* No Hidden Fees */}
      <Box sx={{ mb: 2 }}>
        <Paper
          elevation={0}
          sx={{
            p: {xs: 3.5, sm: 1.5},
            bgcolor: "white",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            width: "100%",
            mb: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            No Hidden Fees
          </Typography>
          <Typography variant="body2">
            You keep <strong>100%</strong> of what your Customers pay, minus
            Stripe's standard processing fees. There are no additional fees from
            Cleri for processing payments.
          </Typography>
        </Paper>
      </Box>
     <Box sx={{ mb: 3 }}>
  <Box sx={{ display: "flex", gap: 2 }}>
    {/* Existing Account Button */}
    <Button
      fullWidth
      onClick={() => {
        setAccountOption("existing");
        handleExistingStripeConnection();
      }}
      sx={{
        p: { xs: 3, sm: 2 },
        border: "2px solid",
        borderColor: accountOption === "existing" ? "#23A26D" : "#e0e0e0",
        borderRadius: 2,
        minHeight: 180,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "none",
        color: "text.primary",
        bgcolor: "background.paper",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow:
          accountOption === "existing"
            ? "0 4px 20px rgba(35, 162, 109, 0.2)"
            : "0 2px 6px rgba(0,0,0,0.08)",
        "&:hover": {
          bgcolor: "rgba(35, 162, 109, 0.08)", // hover background color
          boxShadow: "0 6px 20px rgba(35, 162, 109, 0.15)",
        },
      }}
    >
      <Box
        sx={{
          mb: 1,
          bgcolor: "rgba(35, 162, 109, 0.12)",
          p: 1.5,
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon icon="pajamas:user" width={22} height={22} style={{ color: "#23A26D" }} />
      </Box>
      <Typography variant="h5" gutterBottom>
        I have an account
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Sign in to your existing Stripe account to continue
      </Typography>
    </Button>

    {/* New Account Button */}
    <Button
      fullWidth
      onClick={() => {
        setAccountOption("new");
        handleNewStripeConnection();
      }}
      sx={{
        p: { xs: 3, sm: 2 },
        border: "2px solid",
        borderColor: accountOption === "new" ? "#23A26D" : "#e0e0e0",
        borderRadius: 2,
        minHeight: 180,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "none",
        color: "text.primary",
        bgcolor: "background.paper",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow:
          accountOption === "new"
            ? "0 4px 20px rgba(35, 162, 109, 0.2)"
            : "0 2px 6px rgba(0,0,0,0.08)",
        "&:hover": {
          bgcolor: "rgba(35, 162, 109, 0.08)", // hover background color
          boxShadow: "0 6px 20px rgba(35, 162, 109, 0.15)",
        },
      }}
    >
      <Box
        sx={{
          mb: 1,
          bgcolor: "rgba(35, 162, 109, 0.12)",
          p: 1.5,
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon icon="solar:user-id-linear" width={23} height={23} style={{ color: "#23A26D" }} />
      </Box>
      <Typography variant="h5" gutterBottom>
        I'm new to Stripe
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Create a new Stripe account in just a few minutes
      </Typography>
    </Button>
  </Box>
</Box>



      {/* Navigation Buttons */}
      <Box sx={{ display: "flex", justifyContent: "space-between" , mt: 5 }}>
    <Button
  variant="outlined"
            onClick={handlePrev}

  sx={{
    textTransform: "none",
    borderColor: "transparent",
    color: "text.secondary", // Greyish color from theme
    '&:hover': {
      borderColor: "transparent",
      color: "text.secondary" // Maintains grey color on hover
    }
  }}
>
  Previous
</Button>
       <Button
  variant="outlined"
   onClick={() => handleNext([])}
   size="small"
  sx={{
    textTransform: "none",
    borderColor: "transparent",
    color: "text.secondary", // Greyish color from theme
    '&:hover': {
      borderColor: "transparent",
      color: "text.secondary" // Maintains grey color on hover
    }
  }}
>
Skip for now
</Button>
        <Button variant="contained" color="main" sx={{ textTransform: "none" }} onClick={() => handleNext([])}>
          Next
        </Button>
      </Box>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10000 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/*<ToastContainer />*/}

    </Box>
  );
};

export default StripeSetupPage;